export const isCacheKey = (string: string) => {
    const decoded = Buffer.from(string, 'base64').toString('utf-8');
    return decoded.includes('petm-') || decoded.substring(0, 3).includes(';');
};
